export default __webpack_public_path__ + "static/media/IconDesc_RampInverted_8x8x1.256.a37cef3c.png";